import React from 'react';
import styled from 'styled-components';

import Section from '../../common/Section';

const Wrapper = styled(Section)`
  padding: var(--default-vertical-padding) var(--default-horizontal-padding);
  height: calc(13rem + 2 * var(--default-vertical-padding));
`;

const VerticalLine = styled.div`
  background-color: var(--c-white);
  height: 100%;
  margin: 0 auto;
  width: 1px;
`;

export default () => {
  return (
    <Wrapper>
      <VerticalLine />
    </Wrapper>
  );
};



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/utils/VerticalLine.js